// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-0387fedf]{flex-direction:column;flex-grow:1;font-size:var(--body);line-height:1.4;padding:1.4em}.error[data-v-0387fedf],.header[data-v-0387fedf]{display:flex;justify-content:flex-start}.header[data-v-0387fedf]{align-items:center;margin:0 0 1em}.header h2[data-v-0387fedf]{color:var(--colour-blue);margin:0 0 0 .5em}.error>a[data-v-0387fedf]{display:block;margin-top:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
